
import React from 'react';
import { Leaf } from 'lucide-react';

interface VeganIconProps {
  className?: string;
}

export const VeganIcon: React.FC<VeganIconProps> = ({ className = "w-4 h-4" }) => {
  return <Leaf className={className} />;
};
